import type { Provider } from '@angular/core';
import { InjectionToken } from '@angular/core';

export interface HubSpotFormConfig {
    region: 'eu1';
    portalId: string;
}

export const HUBSPOT_FORM_CONFIG = new InjectionToken<HubSpotFormConfig>('HUBSPOT_FORM_CONFIG');

export function provideHubSpotFormConfig(config: HubSpotFormConfig): Provider {
    return { provide: HUBSPOT_FORM_CONFIG, useValue: config };
}
